export default __webpack_public_path__ + "static/media/step5.8ee8b7de.webp";